.icon {
  width: 28px;
  height: 28px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-size: contain;
}

.icon .primary,
.icon .secondary {
  width: calc(100% * 25 / 33);
  height: calc(100% * 26 / 33);
}

.icon .background {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.businessProcessActivity {
  position: relative;
}

.businessProcessData {
  position: relative;
}
.businessProcessData .primary {
  position: absolute;
  top: -9%;
  left: -5%;
}
.businessProcessData .secondary {
  position: absolute;
  bottom: -12%;
  left: 0;
  right: 0;
  margin: auto;
}

/* slightly bigger in the main menu */
.businessProcessLargeButton {
  width: 42px;
  height: 42px;
}
.businessProcessLargeButton .icon {
  width: 33px;
  height: 33px;
}
